module.exports = __webpack_public_path__ + "static/media/training1.a3a76c37.png";